import React from 'react';
import { Button, Modal } from 'components/ui';
import { Box, Typography } from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

interface NotificationPermissionPromptProps {
  open: boolean;
  onClose(): void;
  onEnable(): void;
}

function NotificationPermissionPrompt ({
  open,
  onClose,
  onEnable,
}: NotificationPermissionPromptProps) {
  return (
    <Modal title="Stay in the Loop!" open={open} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 24,
          maxWidth: 520,
          margin: {
            xs: '0px',
            md: '0 24px',
          },
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 80,
            height: 80,
            borderRadius: '16px',
            backgroundColor: 'primary.main',
            color: 'white',
            flexShrink: 0,
          }}
        >
          <NotificationsActiveIcon sx={{ fontSize: 40 }} />
        </Box>
        <Box
          sx={{
            textAlign: 'left',
            flex: 1,
          }}
        >
          <Typography variant="body1" lineHeight={1.3} fontWeight={600} mb={8}>
            Enable Push Notifications
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={16}>
            Stay updated on events, RSVPs, and important announcements. Never miss what&apos;s happening on campus!
          </Typography>
          <Box
            mt={0}
            display="flex"
            alignItems="center"
            flexDirection="row"
            justifyContent="flex-start"
            gap={24}
          >
            <Button variant="vibrant" minHeight={48} onClick={onEnable}>
              Enable Notifications
            </Button>
            <Typography
              onClick={onClose}
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              Maybe Later
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default NotificationPermissionPrompt;

